export const routes = {
    homePage: "/",
    bookPage: "/buybook",
    registerPage: "/register",
    signinPage: "/signin",
    assessmentPage: "/assessment",
}